const resource = '/admin/v1/applications/fields';

export default $axios => ({
    index() {
        return $axios.get(`${resource}`);
    },

    saveAsMaster(id, payload) {
        return $axios.post(`${resource}/save-as-master/${id}`, payload);
    },

    show(id) {
        return $axios.get(`${resource}/${id}`);
    },

    create(payload) {
        return $axios.post(`${resource}`, payload);
    },

    update(id, payload) {
        return $axios.put(`${resource}/${id}`, payload);
    },

    delete({fieldId, appId}) {
        return $axios.delete(`${resource}/${fieldId}?app_id=${appId}`);
    }
});
